import React, { useEffect, useState } from "react";
import DocImg from "../images/doc.svg";
import RemoveImg from "../images/delete.svg";
import { baseURL } from "../constants/Api";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Decrement from "../images/increment.svg";
import Increment from "../images/decrement.svg";
import ModalSkeleton from "./skeletons/ModalSkeleton";
import ButtonLoader from "./loaders/ButtonLoader";
import {
  checkPastTime,
  checkPastTimeAndMinMaxTime,
  fetchRoomNoAndPhoneNo,
  setRoomNoAndPhoneNo,
  validatePhoneNumber,
} from "../utils/util";
import { useNavigate } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { Box } from "@mui/material";
import BackButton from "../pages/bars/BackButton";
import { TableReservationSubmitButtonClick } from "../utils/Analytics";

function TablePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const restaurantData = location.state;
  const restaurantTable = restaurantData?.restaurantTable ? restaurantData.restaurantTable : null;
  console.log("restaurantData==============",restaurantTable)
  const [categoryArray, setCategoryArray] = useState([]);
  const [firstItem, setFirstItem] = useState([]);
  const [categoryId, setCategoryId] = useState();
  const [occupancy, setOccupancy] = useState(1);
  const [capacity, setcapacity] = useState("");
  const [maxcapacityerror, setmaxcapacityerror] = useState(false);
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const [date, setDate] = useState(`${year}-${month}-${day}`);
  const [time, setTime] = useState(`${hours}:${minutes}:${seconds}`);
  const initialdate = `${year}-${month}-${day}`;
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [tableLoad, setTableLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const isCheckedIn = localStorage.getItem("isCheckedIn");
  const reservationData = JSON.parse(localStorage.getItem("guestDetailsArray"));
  const storedData = fetchRoomNoAndPhoneNo();
  const [roomNo, setRoomNo] = useState(storedData?.room);
  const [mobileNo, setMobileNo] = useState(
    storedData?.phone ? storedData?.phone : localStorage.getItem("phone_no")
  );
  const [mobileValidation, setMobileValidation] = useState(true);
  var datetime = new Date(reservationData?.dateOut);
  var date_out = datetime?.toISOString().split("T")[0];
  const [selectedTime, setSelectedTime] = useState("");
  const [timeValue, setTimeValue] = useState(null);
  const [start_time,setstart_time] = useState('');
  const [close_time,setclose_time] = useState('');
  const bookingParams = {
    appUserId: localStorage.getItem("appUserId"),
    reservationId: localStorage.getItem("reservationId"),
    guestId: localStorage.getItem("guestId"),
    hotelId: localStorage.getItem("hotel-id"),
  };

  const handleTimeChange = (newValue) => {
    // console.log("newValue from time================",newValue);
    if (newValue) {
      const formattedTime = dayjs(newValue).format("HH:mm:ss"); // Format the time to 'HH:mm:ss'

      console.log(newValue, formattedTime, "ddd");
      setTimeValue(newValue);
      setSelectedTime(formattedTime);
    } else {
      setSelectedTime(null); // Handle case when no valid time is selected
    }
  };

  const handleDate = (e) => {
    setDate(e.target.value);
    setTime(null);
    console.log("e.target.value",e.target.value)
  };

  const handleCategory = (e) => {
    setCategoryId(e.target.value);

    const hotelCapacity = categoryArray?.find(item => item?.id?.toString() === e.target.value);
    if (hotelCapacity) {
      setcapacity(hotelCapacity?.capacity);
    }

    console.log("e.target.value",e.target.value)
    console.log("hotelCapacity",hotelCapacity?.capacity)

  
  };

  const handleOccupancyChange = (event) => {
    setError(""); 
    const value = event.target.value;
    // if (/^\d*$/.test(value)) {     // previous condition
    if (/^(?:[1-9]\d*|)$/.test(value)) {
        setOccupancy(value); 
        if ( Number(value) < capacity) {
            setmaxcapacityerror(false); 
        } else {
            setmaxcapacityerror(true); 
        }
    }
};


  const getTableData = async () => {
    setTableLoad(true);
    // console.log("restaurantData================",restaurantData)
    let restaurantIds =  restaurantData.restaurantId ? restaurantData.restaurantId : restaurantData.id ;
    // console.log("data from res============",restaurantIds)
    try {
      await axios
        .get(`${baseURL}/api/tableBookingV2/${restaurantIds}`)
        .then(function (response) {
          if (response.data.success) {
            setTableLoad(false);
            if (response.data.data.length != 0) {
              // console.log("response.data.data===================",response.data.data);
              if(restaurantTable === null){
                setCategoryArray(response.data.data);
                setFirstItem(response.data.data[0].id);
                setcapacity(response.data.data[0].capacity)
                setstart_time(response.data.data[0].start_time);
                setclose_time(response.data.data[0].close_time);
              }else{
                let datafromResData =  response.data.data;
                const updatedDataForCategoryArray = [
                  ...datafromResData.filter(item => item.category_name === restaurantTable), 
                  ...datafromResData.filter(item => item.category_name !== restaurantTable)  
                ];
                setCategoryArray(updatedDataForCategoryArray);
                const updatedData = datafromResData.find(item => item.category_name === restaurantTable);
                // console.log("updatedData===============",updatedData.start_time)
                setFirstItem(updatedData.id);
                setOccupancy(restaurantData.noOfGuests);
                const [date, time] = restaurantData.bookingDate.split(" ");
                setSelectedTime(time);
                const dayjs = require('dayjs');
                const dates = dayjs(restaurantData.bookingDate);
                setDate(date);
                setTimeValue(dates);
                setcapacity(updatedData?.capacity)
                setstart_time(updatedData?.start_time);
                setclose_time(updatedData?.close_time);
                setCategoryArray(datafromResData);
              }
            }
          } else {
            setTableLoad(false);
            setError("Tables are not available right now");
          }
        });
    } catch (error) {
      setTableLoad(false);
    }
  };
// console.log("capacity=============",capacity);
// console.log("occupancy==============",occupancy);
  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if(occupancy === ""){
      setError("please fill the Occupancy field ");
    } else if (roomNo === "" && isCheckedIn == "true") {
        setError("Please give room number");
    } else if (!mobileValidation && isCheckedIn != "true") {
        setError("Please give mobile number");
    } else if (!selectedTime) {
        setError("Please give the preffered time");
    } else if (checkPastTimeAndMinMaxTime(date, selectedTime,start_time,close_time)) {
        setError("Table booking is not available for the chosen time");
    } else if(occupancy > capacity){
        setmaxcapacityerror(true);
    } else {
        TableReservationSubmitButtonClick();
        bookTable();
    }
  };


  const handleIncrement = () => {
    if(occupancy < capacity){
      setOccupancy((prev) => parseInt(prev || 0) + 1);
      setmaxcapacityerror(false)
    }else{
      setmaxcapacityerror(true)
    }
  };

  const handleDecrement = () => {
    if (occupancy > 1) {
      setOccupancy((prev) => Math.max(0, parseInt(prev || 0) - 1));
      setmaxcapacityerror(false)
    }
  };

  const bookTable = async () => {
    var data = JSON.stringify({
      id:restaurantTable === null ? null : restaurantData.id,
      hotelId: bookingParams.hotelId,
      restaurantId:restaurantTable === null ? restaurantData.id : restaurantData.restaurantId,
      reservationId: bookingParams.reservationId,
      roomNumber: isCheckedIn !== "false" ? roomNo : null,
      guestId: bookingParams.guestId,
      tableCategoryId: categoryId ? categoryId : firstItem,
      seat: occupancy,
      date: `${date} ${selectedTime}`,
      appUserId: bookingParams.appUserId,
      contactNumber: mobileNo,
    });
    setLoading(true);
    try {
      const method = restaurantTable === null ? "post" : "put";
      const endpoint = restaurantTable === null ? "reserveTableV21" : "tableBookingUpdate";
      await axios({
        method:method,
        url: `${baseURL}/api/${endpoint}`,
        data: data,
        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        if (response.data.success) {
          setLoading(false);
          setSuccess(true);
          setRoomNoAndPhoneNo(roomNo, mobileNo);
          setTimeout(() => {
            navigate("../order-history");
          }, 2000);
        } else {
          setLoading(false);
          setError(response.data?.message);
        }
      });
    } catch (error) {
      setLoading(false);
      setError("Something went wrong..");
    }
  };

  const handleRoomNo = (e) => {
    setRoomNo(e.target.value);
    setError("");
  };

  const handleMobile = (number) => {
    if (/^[0-9+-]*$/.test(number)) {
      setMobileNo(number);
    }
    setError("");
    setMobileValidation(validatePhoneNumber(number));
  };

  useEffect(() => {
    getTableData();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-[#171538] p-6">
     <div className="flex items-center gap-3">
        <BackButton />
        <div className="guestName  sm:text-center text-left">Table Reservation</div>
      </div> 
      {!tableLoad ? (
        <div className="w-full max-w-xl mx-auto">
          {categoryArray.length !== 0 && (
            <div className="flex flex-col justify-center mt-4">
              <div className="head text-center mb-4">
            
                <div className="mt-3 text-base font-semibold text-left w-3/4  truncate  ">
                  {restaurantData.restaurant_name}
                </div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                <label className="mt-2 text-left text-[#D0D0D0] text-12px font-normal">
                  Table Category
                </label>
                <select value={categoryId ? categoryId : firstItem} onChange={handleCategory} className="mt-2 reqInput-tablereservation">
                  {categoryArray.map((item, i) => (
                    <option key={i} value={item.id}>
                      {item.category_name}
                    </option>
                  ))}
                </select>

                <label className="mt-2 text-left text-[#D0D0D0] text-12px font-normal">
                  Occupancy
                </label>
                <div className=" relative flex items-center   justify-between" style={{marginBottom: '15px',marginTop: '6px'}}>
                  {/* <div className="text-sm font-medium">{occupancy} Person</div> */}
                  <input
                    type="text"
                    value={occupancy}
                    onChange={handleOccupancyChange}
                    className="reqInput"
                  />
                  <div className="flex space-x-6 items-center absolute right-2 top-2">
                  <div className="cursor-pointer">
                      <img
                        src={Decrement}
                        alt="Decrement"
                        onClick={handleDecrement}
                      />
                    </div>
                    <div className="cursor-pointer" onClick={handleIncrement}>
                      <img src={Increment} alt="Increment" />
                    </div> 
                  </div>
                </div>
                  { maxcapacityerror && <h6 className="table-reservation-error-msg">Maximum capacity reached</h6> }
                <label className="mt-2 text-left text-[#D0D0D0] text-12px font-normal">
                  Preferred Date
                </label>
                <input
                  onChange={handleDate}
                  className="mt-2 reqInput-tablereservation"
                  type="date"
                  value={date}
                  min={initialdate}
                  max={date_out}
                />
                <label className="mt-2 text-left text-[#D0D0D0] text-12px font-normal">
                  Preferred Time
                </label>
                <div className="reqInput-tablereservation-mobile-number">
                  <Box sx={{ width: "100%" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                        }}
                      >
                        <TimePicker
                          fullWidth
                          value={timeValue}
                          onChange={(val) => handleTimeChange(val)}
                          slotProps={{ textField: { placeholder: 'Please select the time' } }}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "4px",
                              background: "#342f4f",
                              outline: "none",
                              padding: "10px 16px",
                              border: "none",
                              color: "#fff",
                              width: "100%",
                            },
                            "& .MuiInputBase-input": {
                              padding: "0",
                              color: "inherit",
                              borderRadius: "4px",
                            },
                            "& .MuiSvgIcon-root": {
                              color: "#fff",
                            },
                            "&.Mui-focused .MuiInputBase-root": {
                              borderColor: "transparent",
                              boxShadow: "none",
                            },
                            "&:hover .MuiInputBase-root": {
                              borderColor: "transparent",
                            },
                          }}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>
                </div>
                {isCheckedIn !== "false" ? (
                  <>
                    <label className="mt-2 text-left text-[#D0D0D0] text-12px font-normal">
                      Room Number
                    </label>
                    <input
                      onChange={handleRoomNo}
                      className="mt-2 reqInput-tablereservation"
                      type="text"
                      value={roomNo}
                    />
                  </>
                ) : (
                  <>
                    <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
                      Mobile No.
                    </label>
                    <input
                      onChange={(e) => handleMobile(e.target.value)}
                      value={mobileNo}
                      className="mt-2 reqInput-tablereservation"
                      type="text"
                    />
                    {/* {!mobileValidation && (
                      <span className="text-red-500 text-sm">
                        Invalid number
                      </span>
                    )} */}
                  </>
                )}

                <button disabled={loading} className="bookBtn mt-8 relative">
                  <span>{restaurantTable === null ? "Book Now" : "Update Booking"}</span>
                  {loading && <ButtonLoader />}
                </button>
              </form>
            </div>
          )}
        </div>
      ) : (
        <ModalSkeleton />
      )}

      {error && (
        <div className="w-full text-center mt-3 text-red-500">{error}</div>
      )}
      {error == "timeCheck" && (
        <div className="w-full text-center mt-3 text-red-500">
        Table reservations are unavailable at the moment. Please check the working hours for more information
        </div>
      )}
      {success && (
        <div className="w-full text-center mt-3 text-green-500">
          Successfully Requested!
        </div>
      )}
    </div>
  );
}

export default TablePage;
